<template>
    <div class="survey-text-container">
        <span>{{field.name}}</span>
        <md-field>
            <label>{{readonlyMode ? '': field.placeholder || "Wprowadź tekst"}}</label>
            <md-input v-model="model" v-on:change="onModelChange" :disabled="readonlyMode"></md-input>
        </md-field>
    </div>
</template>

<script>
import store from '../../store';

export default {
  name: 'SurveyText',
  data() {
    return {
      model: this.field.value,
      readonlyMode: store.state.visit.readonlyMode,
    };
  },
  methods: {
    onModelChange() {
      this.$emit('modelChange', {
        newVal: this.model,
        oldVal: this.field.value,
        fieldId: this.field.id,
      });
      this.field.value = this.model;
      this.$emit('nodeChange', this.field);
    },
  },
  props: ['field'],
};
</script>

<style src="./SurveyText.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/SurveyText/SurveyText.vue